import React, { useState, useEffect, useRef, useCallback } from 'react';

export default function Help() {
    const [html, setHtml] = useState('');
    const [toc, setToc] = useState([]);
    const [activeId, setActiveId] = useState('');
    const contentRef = useRef(null);

    useEffect(() => {
        // Load our own help.html — trusted content generated at build time, not user input
        fetch('/help.html')
            .then(r => r.text())
            .then(raw => {
                const match = raw.match(/<body[^>]*>([\s\S]*)<\/body>/i);
                const body = match ? match[1] : raw;
                setHtml(body);
            })
            .catch(() => setHtml('<p>Failed to load help content.</p>'));
    }, []);

    useEffect(() => {
        if (!contentRef.current || !html) return;
        const headings = contentRef.current.querySelectorAll('h1, h2, h3');
        const items = [];
        headings.forEach((h, i) => {
            const id = `help-${i}`;
            h.id = id;
            items.push({ id, text: h.textContent, level: parseInt(h.tagName[1]) });
        });
        setToc(items);
        if (items.length > 0) setActiveId(items[0].id);
    }, [html]);

    const handleScroll = useCallback(() => {
        if (!contentRef.current) return;
        const headings = contentRef.current.querySelectorAll('[id^="help-"]');
        let current = '';
        for (const h of headings) {
            const rect = h.getBoundingClientRect();
            if (rect.top <= 120) current = h.id;
        }
        if (current) setActiveId(current);
    }, []);

    useEffect(() => {
        const scrollParent = document.querySelector('.page-content');
        if (scrollParent) {
            scrollParent.addEventListener('scroll', handleScroll);
            return () => scrollParent.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll, html]);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    // Trusted static content from our own build — safe to render as HTML
    // eslint-disable-next-line react/no-danger
    const contentMarkup = { __html: html };

    return (
        <div className="help-layout">
            <nav className="help-toc">
                <div className="help-toc__title">On this page</div>
                {toc.map(item => (
                    <a
                        key={item.id}
                        href={`#${item.id}`}
                        className={`help-toc__item help-toc__item--h${item.level}${activeId === item.id ? ' help-toc__item--active' : ''}`}
                        onClick={e => { e.preventDefault(); scrollTo(item.id); }}
                    >
                        {item.text}
                    </a>
                ))}
            </nav>
            <div className="help-content" ref={contentRef} dangerouslySetInnerHTML={contentMarkup} />
        </div>
    );
}
